class KorveySearch {

  constructor() {

    this.search = document.querySelector('#KorveySearch');

    if (!this.search) return;

    this.input = this.search.querySelector('#KorveySearchInput');

    this.defaultContent =
      this.search.querySelector('#KorveySearchDefault');

    this.resultsContainer =
      this.search.querySelector('#KorveySearchResults');

    this.closeButton =
      this.search.querySelector('.korvey-search__close');

    this.overlay =
      this.search.querySelector('.korvey-search__overlay');

    this.clearButton =
      this.search.querySelector('.korvey-search__clear');

    this.abortController = null;

    this.debounceTimer = null;

    this.init();

  }


  init() {

    document.addEventListener('click', (event) => {

      const trigger = event.target.closest(
        '.header__icon--search, .korvey-search-trigger'
      );

      if (trigger) {

        event.preventDefault();

        this.open();

      }

    });


    this.input.addEventListener(
      'input',
      this.debounce(() => {

        this.handleSearch();

      }, 250)
    );


    this.closeButton.addEventListener(
      'click',
      () => this.close()
    );


    this.overlay.addEventListener(
      'click',
      () => this.close()
    );


    this.clearButton.addEventListener(
      'click',
      () => this.clear()
    );


    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Escape' &&
          this.search.classList.contains('is-active')
        ) {

          this.close();

        }

      }
    );


    this.search.querySelectorAll(
      '[data-search-term]'
    ).forEach((button) => {

      button.addEventListener(
        'click',
        () => {

          const term =
            button.dataset.searchTerm;

          this.input.value = term;

          this.handleSearch();

          this.input.focus();

        }
      );

    });

  }


  open() {

    this.search.classList.add('is-active');

    this.search.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'korvey-search-open'
    );

    setTimeout(() => {

      this.input.focus();

    }, 300);

  }


  close() {

    this.search.classList.remove(
      'is-active'
    );

    this.search.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'korvey-search-open'
    );

  }


  clear() {

    this.input.value = '';

    this.resultsContainer.innerHTML = '';

    this.resultsContainer.hidden = true;

    this.defaultContent.hidden = false;

    this.input.focus();

  }


  handleSearch() {

    const searchTerm =
      this.input.value.trim();

    if (!searchTerm.length) {

      this.resultsContainer.innerHTML = '';

      this.resultsContainer.hidden = true;

      this.defaultContent.hidden = false;

      return;

    }

    this.defaultContent.hidden = true;

    this.resultsContainer.hidden = false;

    this.getResults(searchTerm);

  }


  async getResults(searchTerm) {

    if (this.abortController) {

      this.abortController.abort();

    }

    this.abortController =
      new AbortController();


    const params = new URLSearchParams();

    params.set(
      'q',
      searchTerm
    );

    params.set(
      'section_id',
      'korvey-predictive-search'
    );

    params.set(
      'resources[type]',
      'product,collection,query'
    );

    params.set(
      'resources[limit]',
      '6'
    );

    params.set(
      'resources[limit_scope]',
      'each'
    );


    try {

      this.resultsContainer.classList.add(
        'is-loading'
      );


      const response = await fetch(

        `${window.Shopify.routes.root}search/suggest?${params.toString()}`,

        {
          signal:
            this.abortController.signal
        }

      );


      if (!response.ok) {

        throw new Error(
          `Search error: ${response.status}`
        );

      }


      const text =
        await response.text();


      const html =
        new DOMParser()
          .parseFromString(
            text,
            'text/html'
          );


      const section =
        html.querySelector(
          '#shopify-section-korvey-predictive-search'
        );


      if (section) {

        this.resultsContainer.innerHTML =
          section.innerHTML;

      }

    } catch (error) {

      if (
        error.name !== 'AbortError'
      ) {

        console.error(
          'KORVÉY Search Error:',
          error
        );

      }

    } finally {

      this.resultsContainer.classList.remove(
        'is-loading'
      );

    }

  }


  debounce(callback, delay = 250) {

    return (...args) => {

      clearTimeout(
        this.debounceTimer
      );

      this.debounceTimer =
        setTimeout(() => {

          callback.apply(
            this,
            args
          );

        }, delay);

    };

  }

}


document.addEventListener(
  'DOMContentLoaded',
  () => {

    new KorveySearch();

  }
);